export default defineNuxtPlugin({
  parallel: true,
  async setup() {
    const path = '/sprite.svg'
    const sprite = await useFetch<Blob>(path)

    if (sprite.data.value) {
      const reader = new FileReader()

      reader.readAsText(sprite.data.value)

      reader.onload = (e) => {
        const el = document.createElement('div')
        el.classList.add('sprite-container')
        el.innerHTML = (e.target as any).result as string
        document.body.appendChild(el)
      }
    }
  },
})
